import {getManagerHeader} from "../Login/functions";
import axios from "axios";
import {baseCmsApiUrl} from "../../assets/Constants";
import {base64DecodeUnicode} from "../../assets/functions";

export const getAllCurrencies = async () => {
    const headers = getManagerHeader();

    return axios.get(baseCmsApiUrl + 'currencies', {headers})
        .then((response) => {
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}

export const getAllCurrenciesObject = async () => {
    const allCurrencies = await getAllCurrencies();
    const allCurrenciesObject = allCurrencies.map((currency) => {
        return {
            id : currency.id,
            name : currency.name,
            rate : currency.rate,
        }
    });

    return allCurrenciesObject;
}

export const getCurrencyById = async (id) => {
    const headers = getManagerHeader();

    return axios.get(baseCmsApiUrl + `currencies/${id}`, {headers})
        .then((response) => {
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}